import React from 'react';
import { Banner, Dialog, Layout } from '@neptune/shared/venus-ui';

export const AlreadyInvitedModal: React.FC<{
  isOpen: boolean;
  close: () => void;
  withProjectInfo?: boolean;
}> = ({ isOpen, close, withProjectInfo }) => {
  return (
    <Dialog
      isOpen={isOpen}
      title="Already invited"
      primaryButtonLabel="OK"
      onPrimaryButtonClick={close}
      onClose={close}
      role="already-invited-modal"
    >
      <Layout.Column spacedChildren="lg">
        <Dialog.Text>This user is already invited / already member of the workspace.</Dialog.Text>
        {withProjectInfo && (
          <Banner type="warning" dataRole="already-invited-project-case-banner">
            Members of the workspace must be added to project by username, not by email.
          </Banner>
        )}
      </Layout.Column>
    </Dialog>
  );
};
